export default "__VITE_ASSET__15d581f9__"